export default __webpack_public_path__ + "static/media/GammaTable1Img.8c2f05b0.jpg";